import React, { useEffect } from 'react';

export default function MoblyxMsg() {
  useEffect(() => {
    document.title = 'PurCo - The damage recovery specialists';
    document.head.querySelector('meta[name="description"]').content = 'PurCo, one of the largest independent risk management companies devoted exclusively to loss prevention and professional claims resolution for the vehicle rental sector, bring you a damage inspection App powered by Moblyx and M Inspect.';
    document.head.querySelector('meta[name="keywords"]').content = 'Vehicle Inspection App, Compliance Inspection Solutions, Asset Inspection App, Damage Recovery App, Rental Inspection App, Damage Inspection App';
  }, []);

  // This is a temporary placeholder and should not be seen, purinspect.com should redirect to purinspect.com/purco
  // - edit the Moblyx site under the moblyx-site folder

  return (
    <div style={{ position: "absolute", top: '100px', left: 'calc(50vw - 150px)' }}>
      Please go to <a href="/purco">purinspect.com/purco</a>
    </div>
  );
}
